import maddyApi from '@/services/maddyApi';
import * as Sentry from '@sentry/browser';

export default {
  namespaced: true,
  state: {
    accessToken: null,
    token: {
      iat: null,
      exp: null,
    },
    user: null,
    error: null,
  },
  getters: {
    isAdmin: state => {
      return state?.user.admin;
    },
    name: state => {
      return state?.user.displayName || state?.user.username;
    },
    subscription: state => {
      let converted = '';

      if (!state?.user?.subscription) {
        converted = 'Not subscribed';
      } else {
        switch (state.user.subscription) {
          case '1000':
            converted = 'Tier 1';
            break;
          case '2000':
            converted = 'Tier 2';
            break;
          case '3000':
            converted = 'Tier 3';
            break;
          case 'prime':
            converted = 'Prime';
            break;
          default:
            converted = 'Not subscribed';
            break;
        }
      }

      return converted;
    },
    isLoggedIn: state => {
      if (!state.user || !state.token) return false;
      if (state.token && state.token.exp) {
        const now = new Date().getTime();
        if (now > state.token.exp) {
          return false;
        }
      }
      return true;
    },
  },
  actions: {
    async login({ commit }, twitchAccessToken) {
      const endpoint = 'auth/login';
      const body = { twitchAccessToken };
      const options = { withCredentials: true };
      try {
        const { data } = await maddyApi.post(endpoint, body, options);
        const { token, user } = data;

        Sentry.setUser({
          id: user.id,
          username: user.username,
        });
        commit('SET_TWITCH_ACCESS_TOKEN', twitchAccessToken);
        commit('SET_TOKEN', token);
        commit('SET_USER', user);
      } catch (err) {
        commit('SET_ERROR', err.data);
      }
    },
    logout({ commit }) {
      commit('LOGOUT');
    },
  },
  mutations: {
    SET_ERROR(state, errorData) {
      state.error = errorData;
    },
    SET_TWITCH_ACCESS_TOKEN(state, accessToken) {
      state.accessToken = accessToken;
    },
    SET_TOKEN(state, tokenInformation) {
      state.token.exp = tokenInformation.exp;
      state.token.iat = tokenInformation.iat;
    },
    SET_USER(state, userProfile) {
      state.user = userProfile;
    },
    LOGOUT(state) {
      state.user = null;
      state.token = {
        iat: null,
        exp: null,
      };
    },
  },
};
